<template>
    <div class="container">
        <div class="aboutmain">
            <div class="row">
                <div class="col-md-12">
                    <h2><b>Shirt</b> Collection's</h2>
                    <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="0">
                    <!-- Carousel indicators -->  
                    <!-- Wrapper for carousel items -->
                    <div class="carousel-inner">
                        <div class="item active">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-1.jpg" class="img-responsive" alt="">									
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Men’s Off White Color</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳2799.00</strike> <b>৳2099.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-2.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Premium Maroon Formal</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1800.00</strike> <b>৳1200.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>		
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-3.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Ultra Slim Fit Printed Formal</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1850.00</strike> <b>৳1350.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>								
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-4.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Premium Check Shirt</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳2900.00</strike> <b>৳2300.99</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-5.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Men’s Cream Color</h4>
                                            <p class="item-price"><strike>৳1850.00</strike> <span>৳1550.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-6.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Maroon Color Shirt</h4>
                                            <p class="item-price"><strike>৳1550.99</strike> <span>৳1299.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-7.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Maroon Color Check</h4>
                                            <p class="item-price"><strike>৳2200.00</strike> <span>৳1800.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-8.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Striped White Shirt</h4>
                                            <p class="item-price"><strike>৳1950.00</strike> <span>৳1670.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>						
                            </div>
                        </div>
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-9.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Blue Luxury Slim-Fit</h4>
                                            <p class="item-price"><strike>৳1899.00</strike> <span>৳1550.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-10.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Printed Ultra Slim Fit</h4>
                                            <p class="item-price"><strike>৳2100.00</strike> <span>৳1900.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-11.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>White Premium Check Shirt</h4>
                                            <p class="item-price"><strike>৳1699.00</strike> <span>৳1299.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>	
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-12.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Men’s Formal Check Shirt</h4>
                                            <p class="item-price"><strike>৳2150.00</strike> <span>৳1850.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>



                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-13.jpg" class="img-responsive" alt="">									
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Classic Black Double Pocket</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1999.00</strike> <b>৳1650.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-14.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Printed Casual Shirt</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1899.00</strike> <b>৳1500.99</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>		
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-15.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Classic Olive Double</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳2200.00</strike> <b>৳1800.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>								
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-16.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Classic Check Shirt</h4>									
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <p class="item-price"><strike>৳1900.00</strike> <b>৳1700.00</b></p>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-17.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Printed Band Collar Shirt</h4>
                                            <p class="item-price"><strike>৳2350.00</strike> <span>৳2100.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-18.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Floral Printed Casual</h4>
                                            <p class="item-price"><strike>৳1800.00</strike> <span>৳1650.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-19.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Ultra Slim Fit Casual</h4>
                                            <p class="item-price"><strike>৳1700.00</strike> <span>৳1550.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-20.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Men’s Dress Shirt with Mask</h4>
                                            <p class="item-price"><strike>৳2050.00</strike> <span>৳1800.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>						
                            </div>
                        </div>
                        <div class="item">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-21.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Ultra Slim Fit Printed</h4>
                                            <p class="item-price"><strike>৳1900.00</strike> <span>৳1600.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-22.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Printed Band Collar</h4>
                                            <p class="item-price"><strike>৳1850.00</strike> <span>৳1550.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-23.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Ultra Slim Fit Printed</h4>
                                            <p class="item-price"><strike>৳2080.00</strike> <span>৳1950.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-half-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>	
                                <div class="col-sm-3">
                                    <div class="thumb-wrapper">
                                        <span class="wish-icon"><i class="fa fa-heart-o"></i></span>
                                        <div class="img-box">
                                            <img src="/img/shirt-24.jpg" class="img-responsive" alt="">
                                        </div>
                                        <div class="thumb-content">
                                            <h4>Ultra Slim Fit Printed</h4>
                                            <p class="item-price"><strike>৳1880.00</strike> <span>৳1450.00</span></p>
                                            <div class="star-rating">
                                                <ul class="list-inline">
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                                    <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                                                </ul>
                                            </div>
                                            <a style="background-color: #060606;" href="https://m.me/ibrand.bd.shop" class="btn btn-dark">Add to Cart ▹</a>
                                        </div>						
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Carousel controls -->
                    
                </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'ShirtCompo'
    }
</script>

<style  scoped>
    .col-sm-3{
        text-align: center;
        margin: 20px auto;
    }
    .thumb-wrapper{
        margin: 0 auto;
        width: 80%;
        box-shadow: 0 4px 8px 0 rgba(50, 50, 50, 0.2), 0 6px 20px 0 rgba(220, 220, 220, 0.19);
        border-radius: 10px;
    }
    img{
        width: 220px;
    }
    a{
        margin: 20px auto;
    }
    h4{
        font-size: 16px;
    }
    .btn:hover{
        opacity: 0.7;
        transition: all 0.2s ease-in-out;
    }
</style>
